module.exports = __webpack_public_path__ + "img/step04_c_stand_power_left_screws.523110f5.png";